import React, { useCallback, useEffect, useState } from 'react'
import { TtrainingKeyParameterItem } from '../../shared/types/TrainingKeyParameterItem.type'
import { Box, Card, CardContent, Divider, List, ListItem, Skeleton, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import { prepareTrainingParamForCharts, TParamsChartData } from '../../shared/utils/myTrainings'
import { isEmpty } from 'lodash'
import RenderParamChartItem from './RenderParamChartItem'
import SelectPeriod from './SelectPeriod'
import { usePeriodSelector } from '../../hooks/usePeriodSelector'

type PerformanceAnalyticsProps = {
    isLoading: boolean,
    examParams: TtrainingKeyParameterItem[],
    handlePeriodChange: (value?: string) => void
}


function PerformanceAnalytics({ isLoading, examParams, handlePeriodChange }: PerformanceAnalyticsProps) {
    const [mousePosition, setMousePosition] = useState<MouseEvent | undefined>(undefined);
    const [paramsFormatted, setParamsFormatted] = useState<TParamsChartData>([])
    const { periods, period, setPeriod, dateFromPeriod } = usePeriodSelector()

    useEffect(() => {
        setParamsFormatted(prepareTrainingParamForCharts(examParams))
    }, [examParams.length])

    console.log({paramsFormatted});
    

    useEffect(() => {
        handlePeriodChange(dateFromPeriod)
    }, [dateFromPeriod])

    // Handle mouse move and set x and y position
    const handleMouseMove = useCallback((event: any) => {
        if (!event) {
            setMousePosition(undefined);
            return
        }

        setMousePosition(event);
    }, [])

    // Attach global mousemove listener when component mounts
    useEffect(() => {

        let element = document.querySelector('.wrapper')

        element?.addEventListener('mousemove', handleMouseMove);
        return () => {
            element?.removeEventListener('mousemove', handleMouseMove);
        };
    }, [handleMouseMove]);

    
    console.log({paramsFormatted});
    
    
    return (
        <Card>
            <CardContent>
                <Box display={'flex'} flexWrap={'wrap'} gap={1} justifyContent={'space-between'} alignItems={'center'}>

                    <Typography variant='h6'>
                        {t('horse:performanceIndices')}
                    </Typography>

                    <SelectPeriod
                        periods={periods}
                        period={period}
                        onPeriodChange={(value) => setPeriod(value)}
                    />
                </Box>
                <div className='wrapper' style={{ position: 'relative', zIndex: 100 }}>
                    {

                        isLoading ?
                            <Stack direction={'column'} spacing={2} mt={3}>

                                {
                                    [1, 2].map(i => (
                                        <Skeleton variant='rectangular' sx={{ width: '100%', height: '220px' }}></Skeleton>
                                    ))
                                }
                            </Stack>

                            : <List sx={{ mt: 2 }} className='wrapper'>
                                {
                                    isEmpty(paramsFormatted) ?
                                        <Box display={'flex'} justifyContent={'center'}>
                                                <Typography variant='subtitle2'>{t('noIndiceFound')}</Typography>
                                        </Box>
                                        : paramsFormatted.map(param => (
                                            <ListItem divider key={param?.param?.key_parameter_layout?.insight_parameter?.['@id']}>
                                                <RenderParamChartItem
                                                    param={param}
                                                    mousePosition={mousePosition}
                                                />
                                            </ListItem>
                                        ))
                                }
                            </List>
                    }


                </div>
            </CardContent>
        </Card>
    )
}

export default PerformanceAnalytics